import { render, staticRenderFns } from "./VDatetimepicker.vue?vue&type=template&id=089b8125&scoped=true"
import script from "./VDatetimepicker.vue?vue&type=script&lang=js"
export * from "./VDatetimepicker.vue?vue&type=script&lang=js"
import style0 from "./VDatetimepicker.vue?vue&type=style&index=0&id=089b8125&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "089b8125",
  null
  
)

export default component.exports